<template lang="html">
  <section :id="id" class="select-option">
    <span v-if="label" :for="selectId" class="main-label">
      {{ label }}
    </span>
    <div class="slds-form-element">
      <label v-if="topLabel" :for="selectId" class="slds-form-element__label">
        {{ topLabel }}
      </label>
      <div class="slds-form-element__control">
        <div class="slds-select_container">
          <select
            class="slds-select"
            v-if="isSimpleVersion"
            :id="selectId"
            v-model="model"
            @change.stop="onOptionChange"
          >
            <option v-for="(option, index) in options" :key="index">
              {{ option }}
            </option>
          </select>

          <select
            class="slds-select"
            v-else
            :id="selectId"
            v-model="model"
            @change.stop="onOptionChange"
          >
            <option
              v-for="option in options"
              :key="option.uuid"
              :value="option.uuid"
            >
              {{ option.version }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="js">
  import { v4 as uuidv4 } from "uuid";

  export default {
    name: "select-option",
    props: {
      id: String,
      topLabel: String,
      label: String,
      selected: String,
      defaultVersionObject: Object,
      options: {
        type: Array,
        default: function() {
          return []
        }
      }
    },
    data() {
      return {
        model: ""
      }
    },
    watch: {
      selected: function() {
        this.updateModel();
      }
    },
    computed: {
      isSimpleVersion() {
        return !this.defaultVersionObject || !this.defaultVersionObject.uuid;
      },
      selectId() {
        return `select-option-${uuidv4()}`;
      }
    },
    mounted() {
      this.updateModel();
    },
    methods: {
      updateModel() {
        this.model = this.isSimpleVersion ? this.selected : this.defaultVersionObject.uuid;
      },
      onOptionChange() {
        this.$emit("on-select-option-change", this.model, this.id);
      }
    }
  };
</script>

<style scoped lang="scss">
  .select-option {
    display: flex;
    align-items: center;
    .main-label {
      white-space: nowrap;
      margin-right: 0.5rem;
    }
    .slds-form-element {
      flex-grow: 1;
    }
  }
</style>
